<template>
  <header>
    <div class="api-title">
      API
    </div>

    <div class="api-subtitle">
      <span>
        {{ $t('api.subtitle') }}
      </span>

      <a href="https://documenter.getpostman.com/view/15402503/Tzm8Fb5f" target="_blank">
        {{ $t('api.docs') }}
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ApiHeader',
}
</script>

<style scoped>
.api-title {
  min-height: 36px;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;
}
.api-subtitle {
  font-weight: 400;
  font-size: 13px;
  color: #ACACAC;
  max-width: 672px;
  letter-spacing: normal;
  line-height: normal;
  word-break: normal;
}
.api-subtitle > a {
  white-space: nowrap;
  color: #B645EE;
  text-decoration: underline;
  cursor: pointer;
}
</style>
